import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Chart } from 'chart.js';
import { Json2csvService } from 'csvtools-lib';
import { PaymentsReportsPerGatewayZoomCardComponent } from '../payments-reports-per-gateway-zoom-card/payments-reports-per-gateway-zoom-card.component';

@Component({
  selector: 'app-payments-reports-per-gateway-card',
  templateUrl: './payments-reports-per-gateway-card.component.html',
  styleUrls: ['./payments-reports-per-gateway-card.component.scss']
})
export class PaymentsReportsPerGatewayCardComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('perPlatform', { static: false }) perPlatformRef: ElementRef;
  @Input() data;
  ctx;
  myChart;
  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  constructor(private json2csvService: Json2csvService,
              private dialog: MatDialog) { }

  ngOnInit() { }

  ngOnChanges(changes) {
    if (!changes.data.firstChange) {
      this.render(this.data);
    }
  }

  ngAfterViewInit() {
    this.ctx = this.perPlatformRef.nativeElement.getContext('2d');
    this.render(this.data);
  }

  private render(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    this.ctx = this.perPlatformRef.nativeElement.getContext('2d');
    this.myChart = new Chart(this.ctx, {
      type: 'pie',
      responsive: true,
      data: {
        labels: data.map(d => d.platform),
        datasets: [
          {
            label: 'Dataset 1',
            data: data.map(d => d.nbTransactions),
            backgroundColor: data.map((d, i) => this.colors[i] ),
          }
        ]
      },
      options: {
        legend: {
          position: 'right'
        }
      }
    });
  }

  public statZoom() {
    this.dialog.open(PaymentsReportsPerGatewayZoomCardComponent, { data: { data: this.data, title: 'gateways-page.transactions per platform', colors: this.colors } } );
  }

  public generateCSV() {
    const data = [];
    this.data.forEach(d => {
      data.push(d);
    });
    this.json2csvService.setBody(data, ['platform', 'nbTransactions']);
    this.json2csvService.setHeader(['PLATFORM', 'TRANSACTIONS']);
    this.json2csvService.generateCSV('transactionsPerPlatform');
  }
}

